import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useSites = () => {

    const [sites, setSites] = useState([]);
    const [sitesId, setSitesId] = useState(0);
    const [dataSiteSearch, setDataSiteSearch] = useState([]);

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle,setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const history = useHistory();
    
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    

    const [searchSites, setSearchSites] = useState("");
    const [formValues,handleInputChange, reset, handleUpdateValues,] = useForm({
        name:"",
    });
    const [validaciones, setValidaciones] = useState({
        name_valid:false,
    })
    const {name, } = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(sites.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listsites = [];
        sites.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listsites.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setSites(listsites);
    }, [totalPageCount, currentPage])

    const toggle = ()=>{
        setModal(!modal);
    }

    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

   
    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);   
    };

   
    useEffect(()=>{
        getSites();
    },[history.location]);


    const getSites = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "Sites/List");

        if (respuesta.code === 200) {
            let listSite = [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    
                let posicion = index + 1;
                let visibleTable = false;
                
                if (posicion > startItems && posicion <= endItems) {
                    visibleTable = true;
                }

                listSite.push({
                        id_mic_site: data.id_mic_site,
                        name: data.name,
                        visibleTable: visibleTable
                    });
                });
                setSites(listSite);
                setDataSiteSearch(listSite);
                setSiteData(listSite)
            }
        }
    }

    
    const handleCreate = () => {
        handleUpdateValues({
            name: "",
        });

        setValidaciones({
            name_valid: false,
        });

        setSitesId(0);
        setMethod("create");
        setModalTitle("Crear nuevo sitio");
        openDialog("Crear sitio", "create");
    }   

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Sites/Create");
        if (respuesta.code === 200) {
            getSites();
            createSweet("create", "success", "Exito!", "Sitio creado con exito");
            setLoading(false);
            closeDialog();
        }
    }

    const handleUpdate = (id_mic_site) => {
        let site = sites.find(s => s.id_mic_site === id_mic_site);

        handleUpdateValues({
            name: site.name,
        });

        setValidaciones({
            name_valid: false,
        });

        setSitesId(id_mic_site);
        setMethod("update");
        setModalTitle("Modificación del sitio");
        openDialog("Editar sitio", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            id_mic_site: sitesId,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);
        
        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Sites/Update");

        if (respuesta.code === 200) {
            getSites();
            createSweet("create", "info", "Exito!", "Sitio actualizado");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }

    const handleDelete = (id_mic_site) => {
        
        let site = sites.find(s => s.id_mic_site === id_mic_site);

        handleUpdateValues({
            name: site.name,
        });

        setSitesId(id_mic_site);
        setMethod("delete");
        setModalTitle("eliminar");
        setShowDeleteAlert(true);
        setModalAlert(true);
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `Sites/${sitesId}`);

        if (respuesta.code === 200) {
            getSites();
            setLoading(false);
            createSweet("create", "success", "Exito!", "Sitio eliminado");
            setShowDeleteAlert(false);
            setModalAlert(false);
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
       

    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.name === "" || formValues.name.length < 3) {
            newValidations = {
                ...newValidations,
                name_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                name_valid: false
            }
        }
        setValidaciones(newValidations);

        return statusValidation;
    }

    const handleSearchSite = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        dataSiteSearch.forEach(element => {            

            let cadena = element.sites.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setSites(newMethod);
    }

     const handleExportExcelSitio = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

          const _report = sites.map((item, index) => ({
                "#": index + 1,
                Sitios: item.name ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sitios");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catalogo_sitios.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };

    const [siteData, setSiteData] = useState([]);
    const handleSearch = (e) => {
        setSearchSites(e);

        let busqueda = e.toUpperCase();
        let newSites = [];
        if (busqueda === "") {
            setSites([...siteData]);
        } else {
            siteData.forEach(element => {
                let cadena = element.name.toUpperCase();
                if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                    element.visibleTable = true;
                    newSites.push(element);
                }
            });
            setSites([...newSites]);
        }
    }

    
    
    const handleClearSites = () => {
        setSearchSites("");                         
        localStorage.removeItem("globalFilter");    
        setSites(siteData);                    
    };

    

    return {
        sites, name, validaciones,
        method, 
        handleInputChange, handleSearchSite, loading, 
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
       handleDelete, saveDelete,
       nextPage, previousPage, goToPage, totalPageCount, currentPage,

       closeDialog,  showDeleteAlert, closeDeleteAlert, modalAlert,
       handleExportExcelSitio, loadingExport,

       handleClearSites, handleSearch,
       
       searchSites
    }

}




